var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.selectedCount + " kişiyi yanıtlandı olarak işaretle",
        "ok-text": "İşaretle",
        "cancel-text": "İptal",
        width: "450px",
      },
      on: { ok: _vm.handleConfirm, cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("p", [
          _vm._v(
            "Seçili " +
              _vm._s(_vm.selectedCount) +
              " kişi yanıtlandı olarak işaretlenecek. Devam etmek istiyor musunuz?"
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }